// @flow

export const SET_SESSION_ID = 'SET_SESSION_ID';
export const GET_SESSION_ID = 'GET_SESSION_ID';
export const GET_SESSION_ID_DONE = 'GET_SESSION_ID_DONE';
export const GET_SESSION_ID_RETRY = 'GET_SESSION_ID_RETRY';
export const WS_SET_SESSION_ID_REQUEST = 'WS_SET_SESSION_ID_REQUEST';
export const WS_SET_SESSION_ID_SUCCESS = 'WS_SET_SESSION_ID_SUCCESS';
export const WS_SET_SESSION_ID_ERROR = 'WS_SET_SESSION_ID_ERROR';
